import { GridCellProps } from "@progress/kendo-react-grid";
import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import PlantOverviewItem from "./PlantOverviewItem";
import { plantTypeColumnMenu, plantTypeEnumCell } from "./PlantTypeGridColumn";
import { UppercaseCell } from "../../Grid/UppercaseCell";
import { customDecimalFilterCell } from "../../Layout/Filter/CustomDecimalFilterCell";
import { ReadOnlyProps } from "../../Project/EditProject/ReadOnlyProps";

export default function PlantGridColumns({ isReadOnly }: ReadOnlyProps) {
  const uppercaseCell = ({ ...props }: GridCellProps) => {
    return UppercaseCell({
      ...props,
      isReadOnly,
    });
  };

  return [
    columnForField<PlantOverviewItem>("GSDB", {
      locked: true,
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("Name", { width: "300px" }),
    columnForField<PlantOverviewItem>("PlantCode", {
      title: "Two Digit Code",
      width: defaultColumnWidth,
      cell: uppercaseCell,
    }),
    columnForField<PlantOverviewItem>("Street", { width: "300px" }),
    columnForField<PlantOverviewItem>("Zipcode", {
      title: "Postcode",
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("ZipArea", {
      title: "Postcode Area",
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("City", { width: "200px" }),
    columnForField<PlantOverviewItem>("Region", {
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("CountryName", {
      title: "Country",
      width: defaultColumnWidth,
    }),

    columnForField<PlantOverviewItem>("Details", {
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("PlantType", {
      title: "Part Destination",
      hideFilterCell: true,
      columnMenu: plantTypeColumnMenu,
      cell: plantTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("EdcGsdb", {
      title: "Assigned EDC",
      width: defaultColumnWidth,
    }),

    columnForField<PlantOverviewItem>("Latitude", { width: "200px" }),
    columnForField<PlantOverviewItem>("Longitude", { width: "200px" }),
    columnForField<PlantOverviewItem>("MGLatitude", {
      title: "M&G Latitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<PlantOverviewItem>("MGLongitude", {
      title: "M&G Longitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
  ];
}
